import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles<void, 'selected'>()((theme, _params, classes) => ({
	tabsList: {
		marginBottom: theme.spacing.small,
	},
	tab: {
		outline: 'none',
		cursor: 'pointer',
		boxSizing: 'border-box',
		gap: theme.spacing.xxsmall,
		font: theme.typography.labelSm,
		height: theme.button.height.small,
		borderRadius: theme.button.borderRadius,
		border: theme.button.tertiary.button.border?.default,
		color: theme.button.tertiary.label.color.default,
		backgroundColor: theme.button.tertiary.background.color.default,

		'&:focus-visible': {
			color: theme.button.tertiary.label.color.focus,
			backgroundColor: theme.button.tertiary.background.color.focus,
			boxShadow: theme.button.focus,
		},

		[`&.${classes.selected}`]: {
			border: theme.button.tertiary.button.border?.pressed,
			color: theme.button.tertiary.label.color.pressed,
			backgroundColor: theme.button.tertiary.background.color.pressed,
		},
	},
	selected: {},
}));
